import React, { Component } from "react";

import { Spinner } from "../../Components/Spinner/Spinner";
import { connect } from "react-redux";

import ChatCard from "./ChatCard";
import UserList from "./UserList";

import * as SignalR from "@aspnet/signalr";

import projectSettings from "../../assets/Js/projectSettings";

import { callAPI } from "../../assets/Js/backendCommunication";

import { getPlainToken } from "../../assets/Js/tokenHandler";
import parseJwt from "../../assets/Js/jwtParse";

import "../../assets/GlobalStyles/ChatList.css";

import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";
import ModalBody from "../../Components/ModalBody/ModalBody";
import CreateCustomGroup from "../CreateCustomGroup/CreateCustomGroup";

import newMessageNotification from "../../redux/actionCreators/newMessageNotification";
import { setIsMessageUnseen } from "../../assets/Js/localStorage";

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newMessageNotification: (data) => dispatch(newMessageNotification(data)),
  };
};

const usersModalId = "userModal";

const initialState = {
  isLoading: false,
  chatDetail: [],
  chatFilter: [],
  searchInput: "",
  listOverLayIndex: null,
  chatList: [],
  connection: null,
  showUserList: false,
  currentUserId: null,
  SelectedUser: {},
  CurrentScreenNumber: 0,
  ModalChildren: [],
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class ChatList extends Component {
    constructor() {
      super();
      this.state = initialState;
    }

    async componentDidMount() {
      if (this.props?.allAthletesData) {
        this.createModalChildrens();
      }

      let tokenObject = parseJwt(getPlainToken());
      await this.setState({
        currentUserId: tokenObject.name,
      });

      await this.getChat();

      this.buildHubConnection();
    }

    componentDidUpdate(prevProps, prevState) {
      if (
        this.props.idOfUserFromUserList &&
        prevProps.idOfUserFromUserList !== this.props.idOfUserFromUserList
      ) {
        this.setState({
          chatFilter: [...this.state.chatFilter],
          listOverLayIndex: this.props.idOfUserFromUserList.toString(),
        });
      }

      if (prevProps.getNewChatList !== this.props.getNewChatList) {
        this.getChat();
      }

      if (prevProps.resetThisComponent !== this.props.resetThisComponent) {
        this.resetComponent();
      }

      if (prevProps.removeUserWithThisId !== this.props.removeUserWithThisId) {
        let _id = this.props.removeUserWithThisId;
        if (_id) {
          this.removeThisUserFromChatList(_id);
        }
      }

      if (prevProps.allAthletesData !== this.props.allAthletesData) {
        this.createModalChildrens();
      }

      let oldFirstMessageCount = prevProps.firstMessageInfo.firstMessageCount;
      let { firstMessageCount, firstMessage } = this.props.firstMessageInfo;

      if (oldFirstMessageCount !== firstMessageCount) {
        let _hasAlreadyTalkedToThisUser = this.state.chatFilter.find(
          (eachUser) => eachUser.UserId === this.state.SelectedUser.UserId
        );

        if (!_hasAlreadyTalkedToThisUser) {
          let chat = this.state.chatDetail;
          let _newUserInfo = this.state.SelectedUser;

          _newUserInfo.UserId = this.props.idOfUserFromUserList.toString();
          _newUserInfo.Message = firstMessage;
          chat = [_newUserInfo, ...chat];
          this.setState(
            {
              listOverLayIndex: this.state.SelectedUser.UserId,
              chatDetail: [...chat],
              chatFilter: [...chat],
            },
            () => {
              this.state.connection?.off("sendToUser");
              this.buildHubConnection();
            }
          );
        }
      }
    }

    componentWillUnmount() {
      this.state.connection?.off("sendToUser");
    }

    removeThisUserFromChatList = (id) => {
      let _chatDetail = this.state.chatDetail.filter(
        (eachUser) => eachUser.UserId !== id.toString()
      );

      this.setState({
        chatFilter: _chatDetail,
        chatDetail: _chatDetail,
      });
    };

    createModalChildrens = () => {
      const modalChilren = [
        {
          screenNumber: 0,
          component: UserList,
          props: {
            allAthletesData: this.props.allAthletesData,
            usersModalId: usersModalId,
            resetModalInfo: this.resetStateWhenModalIsClosed,
            handleClick: this.handleUserSelection,
          },
        },
        {
          screenNumber: 1,
          component: CreateCustomGroup,
          props: {
            allAthletesData: this.props.allAthletesData,
            modalId: usersModalId,
            getNewChats: this.props.getNewChats,
            handleUserSelection: this.handleUserSelection,
            resetModalInfo: this.resetStateWhenModalIsClosed,
          },
        },
      ];

      this.setState({
        ModalChildren: modalChilren,
      });
    };

    getChat = async () => {
      let url = `${projectSettings.baseUrl}/chats/getchats`;
      let header = true;
      let type = "GET";
      let token = getPlainToken();
      let data = null;
      let response = "";
      if (response === "") {
        this.setState({ isLoading: true });
      }
      response = await callAPI(url, header, type, data, token);
      if (response) {
        this.setState({ isLoading: false });
        if (response.type === "error") {
        } else if (response.type === "success") {
          this.setUnread(response.data);

          this.setState({
            chatDetail: response.data,
            chatFilter: response.data,
          });
        }
      }
    };

    getUserList = () => {
      return this.state.chatDetail?.map((item) => {
        return item.UserId;
      });
    };

    async buildHubConnection() {
      const groupUserListIds = this.getUserList();
      const newConnection = new SignalR.HubConnectionBuilder()
        .withUrl(
          `${projectSettings.baseUrl}/ChatUserHub?userId=${this.state.currentUserId}`
        )
        .configureLogging(SignalR.LogLevel.Information)
        .build();

      await this.setState({
        connection: newConnection,
      });

      let tempConnection = this.state.connection;

      if (tempConnection) {
        tempConnection
          .start()
          .catch(function (err) {
            return console.error(err.toString());
          })
          .then(function () {
            tempConnection.invoke("getconnectionId", groupUserListIds);
          });

        this.state.connection.on("sendToUser", async (response) => {
          if (response) {
            let filterUserId = response.recieverId;
            let messageIndex = null;

            // check if user has already chatted with this person, if it has then get it's chat list index
            let LatestMesssage = this.state.chatDetail.find((item, index) => {
              if (item.UserId === filterUserId) {
                messageIndex = index;
                return item;
              }
            });

            if (LatestMesssage === undefined) {
              LatestMesssage = {};
              LatestMesssage.UserName = response.userName;
              LatestMesssage.image = response.userImage;
            }

            LatestMesssage.Message = response.message;
            LatestMesssage.Date = response.date;
            LatestMesssage.GroupType = response.groupType;

            // update unreads if user's messages are not open in message section (not currently chating)
            if (this.state.listOverLayIndex !== LatestMesssage.UserId) {
              LatestMesssage.UnReads = response.userUnReads.find(
                (user) => user.userId === this.state.currentUserId
              )?.unreads;
            } else {
              LatestMesssage.UnReads = 0;
            }

            LatestMesssage.IsGroup = response.isGroup;
            LatestMesssage.UserId = response.recieverId;

            let newMessages = this.state.chatDetail;

            // if someone has messaged this user then remove that person from chat list and bring it to top
            if (messageIndex !== null) {
              newMessages.splice(messageIndex, 1);
            }
            newMessages.unshift(LatestMesssage);

            // new chat list is created
            await this.setState({
              chatDetail: [...newMessages],
              chatFilter: [...newMessages],
            });

            // show message indicator in nav bar only if user is not currently chating with that person
            if (filterUserId !== this.state.listOverLayIndex) {
              this.props.newMessageNotification(true);
              setIsMessageUnseen(true);
            } else {
              this.props.newMessageNotification(false);
              setIsMessageUnseen(false);
            }
          }
        });
      }
    }

    handleUserSelection = ({
      userId,
      groupId,
      UserName,
      image,
      isGroup,
      index,
      groupType,
    }) => {
      let chat = this.state.chatDetail;
      if (index !== undefined) {
        chat[index].UnReads = 0;
      }

      let _selectedUser = {
        UserId: userId,
        UserName,
        Image: image,
        GroupType: groupType,
      };

      this.setState({
        listOverLayIndex: userId,
        chatDetail: chat,
        chatFilter: chat,
        SelectedUser: { ..._selectedUser },
      });

      this.props.changeMessageList({
        userId,
        groupId,
        UserName,
        image,
        isGroup,
        groupType,
      });
      this.setUnread(this.state.chatFilter);
    };

    setUnread = (allUsers) => {
      let _hasUnreads = allUsers.some((item) => item.UnReads > 0);

      this.props.newMessageNotification(_hasUnreads);
      setIsMessageUnseen(_hasUnreads);
    };

    searchChatDetail = (value) => {
      if (value.length === 0) {
        this.setState({
          chatFilter: this.state.chatDetail,
        });
        return;
      }
      let newUser = this.state.chatDetail.filter((item) => {
        if (item.UserName.toLocaleLowerCase().includes(value.toLowerCase()))
          return item;
      });
      this.setState({
        chatFilter: newUser,
      });
    };

    goToPrevScreen = () => {
      let { CurrentScreenNumber } = this.state;

      if (CurrentScreenNumber) {
        this.setState({
          CurrentScreenNumber: --CurrentScreenNumber,
        });
      }
    };

    goToNextScreen = () => {
      let { CurrentScreenNumber, ModalChildren } = this.state;

      if (CurrentScreenNumber < ModalChildren.length) {
        this.setState({
          CurrentScreenNumber: ++CurrentScreenNumber,
        });
      }
    };

    resetStateWhenModalIsClosed = () => {
      this.setState(
        {
          CurrentScreenNumber: 0,
          showUserList: false,
        },
        () => {
          this.createModalChildrens();
        }
      );
    };

    resetComponent = () => {
      this.setState(initialState);
    };

    render() {
      return (
        <div className="sidepanel border">
          <div className="profile border-bottom mt-2">
            <div>
              <div className="wrap">
                <DisplayPicture
                  image={this.props.userData.Image}
                  className="profile-img"
                />
                <p className="mt-3">
                  {this.props.userData &&
                    this.props.userData.FirstName +
                      " " +
                      this.props.userData.LastName}
                </p>
              </div>
            </div>
            <div className="d-flex align-items-center search pl-3 pr-3 pt-1 pb-1 mb-3">
              <i className="mdi mdi-magnify iconSizeSmall icon"></i>
              <input
                type="text"
                className="search-input"
                onChange={(e) => {
                  this.searchChatDetail(e.target.value);
                }}
                placeholder="Search contacts..."
              />
              <button
                className="addButton primaryBgColor"
                data-toggle="modal"
                data-target={`#${usersModalId}`}
                onClick={() => {
                  this.setState({ showUserList: true });
                }}
              >
                <i className="mdi mdi-plus"></i>
              </button>
            </div>
          </div>
          <div className="contacts tertiaryScrollBar primaryScrollBar">
            <ul className="list-style-none">
              {this.state.isLoading ? (
                <Spinner />
              ) : this.state.chatFilter.length > 0 ? (
                this.state.chatFilter.map((item, key) => {
                  return (
                    <ChatCard
                      key={key}
                      index={key}
                      item={item}
                      listOverLayIndex={this.state.listOverLayIndex}
                      handleClick={this.handleUserSelection}
                    />
                  );
                })
              ) : (
                <div className="text-center mt-3">No Chats Found</div>
              )}
            </ul>
          </div>

          {/* All Users Modal */}
          {this.state.showUserList && (
            <div
              className="modal fade"
              id={usersModalId}
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content border-0">
                  <div class="modal-header">
                    {this.state.CurrentScreenNumber > 0 && (
                      <div
                        className="noBgBtn mr-2"
                        onClick={this.goToPrevScreen}
                      >
                        <span className="mdi mdi-arrow-left pointerCursor"></span>
                      </div>
                    )}
                    <h5 class="modal-title">
                      {this.state.CurrentScreenNumber
                        ? "Create New Group"
                        : "Athletes"}
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.resetStateWhenModalIsClosed}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div className="modal-body">
                    <ModalBody
                      CurrentScreenNumber={this.state.CurrentScreenNumber}
                      ModalChildren={this.state.ModalChildren}
                      goToPrevScreen={this.goToPrevScreen}
                      goToNextScreen={this.goToNextScreen}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* All Users Modal end */}
        </div>
      );
    }
  }
);
